var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0132 10.15C18.7436 9.88035 18.3065 9.88035 18.0369 10.15L13.4343 14.7525C13.1647 15.0221 13.1647 15.4593 13.4343 15.7289C13.7039 15.9985 14.141 15.9985 14.4107 15.7289L17.8347 12.3049V21.6843C17.8347 22.0656 18.1438 22.3747 18.5251 22.3747C18.9063 22.3747 19.2154 22.0656 19.2154 21.6843V12.3049L22.6394 15.7289C22.909 15.9985 23.3462 15.9985 23.6158 15.7289C23.8854 15.4593 23.8854 15.0221 23.6158 14.7525L19.0132 10.15ZM10.9308 21.6843C10.9308 21.303 10.6217 20.9939 10.2404 20.9939C9.85914 20.9939 9.55005 21.303 9.55005 21.6843V25.3663C9.55005 26.0377 9.81675 26.6816 10.2915 27.1563C10.7662 27.6311 11.4101 27.8978 12.0815 27.8978H24.9686C25.64 27.8978 26.2839 27.6311 26.7586 27.1563C27.2333 26.6816 27.5 26.0377 27.5 25.3663V21.6843C27.5 21.303 27.191 20.9939 26.8097 20.9939C26.4284 20.9939 26.1193 21.303 26.1193 21.6843V25.3663C26.1193 25.6715 25.998 25.9642 25.7823 26.18C25.5665 26.3958 25.2738 26.517 24.9686 26.517H12.0815C11.7763 26.517 11.4836 26.3958 11.2678 26.18C11.052 25.9642 10.9308 25.6715 10.9308 25.3663V21.6843Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.37dfda888873ba437f0c1f6e161b8a9c.svg";
export { ForwardRef as ReactComponent };